import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import Breadcrumbs from "../../../../shared/components/Breadcrumbs";
import {
  CATEGORYFORM,
  SAVE,
  BACKTOLIST,
  CATEGORIES,
} from "../../../../shared/constants/Constants";
import FormikCreatableSelect from "../../../../shared/components/FormikCreatableSelect";
import FormikSelectField from "../../../../shared/components/FormikSelectField";
import FormikCheckboxField from "../../../../shared/components/FormikCheckboxField";
import DefaultButton from "../../../../shared/components/DefaultButton";
import { loadDepartmentDataRequest } from "../../../employee_departments/redux/Actions";
import { loadDivisionDataRequest } from "../../../division/redux/Actions";
import {
  loadGroupByTypeAdminGetDataRequest,
  loadGroupByTypeUserGetDataRequest,
  loadGroupByIDJobTitlesGetDataRequest,
} from "../../../group_jobtitles/redux/Actions";
import {
  loadCategorySubCategoryDataRequest,
  loadCategoryFormAddDataRequest,
  loadCategoryGetDataRequest,
  loadCategoryUpdateDataRequest,
  loadCategoryDeleteDataRequest,
  resetCategoryFormUpdateData,
} from "../redux/Actions";
import { loadQuestionTemplateDataRequest } from "../../questions/redux/Actions";
import CategoryQuestions from "./CategoryQuestions";
import CategoryRoutingRules from "./CategoryRoutingRules";
import CategoryQT from "./CategoryQT";
import WorkflowDepartments from "./WorkflowDepartments";
import { PrevNextButtons } from "../../../../shared/components/PrevNextButtons";
import CategoryInheritFrom from "./CategoryInheritFrom";
import { loadCompanyDataRequest } from "../../../company/redux/Actions";

const ticketTypes = [
  { value: "Ticket", label: "Ticket" },
  { value: "Workflow", label: "Workflow" },
];

// const companies = [
//   { value: "TPR", label: "TPR" },
// ];

const CategoryForm = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [saveType, setSaveType] = useState(""); // "save" or "saveAndNew"
  const [subCategories, setSubCategories] = useState([]);
  const [employees, setEmployees] = useState([]);
  const { userGroup, adminGroup, group } = useSelector(
    (store) => store.groupJobtitle
  );
  const { categories, category, loading } = useSelector(
    (store) => store.categories
  );
  let {companies } = useSelector((state) => state.company);
  
  const { questionlist } = useSelector((state) => state.question);
  const [shouldReload, setShouldReload] = useState(false);
  // const [selectedTemplateId, setSelectedTemplateId] = useState("");
  // const selectedTemplate = questionlist?.data?.find(
  //   (tpl) => tpl.id === Number(selectedTemplateId)
  // );
  const [dbSnapshot, setDbSnapshot] = useState(null);
  useEffect(() => {
    dispatch(loadCategorySubCategoryDataRequest());
    dispatch(loadGroupByTypeAdminGetDataRequest("admin"));
    dispatch(loadGroupByTypeUserGetDataRequest("user"));
    if (id && !Number.isNaN(Number(id))) {
      dispatch(loadCategoryGetDataRequest(id));
    }
    dispatch(loadDivisionDataRequest());
    dispatch(loadQuestionTemplateDataRequest());
    dispatch(loadCompanyDataRequest());
  }, [dispatch, id]);

const isEditMode = !!id && !Number.isNaN(Number(id));

const initialValues =
  isEditMode && category && Object.keys(category).length > 0
      ? {
          categories: {
            category: category?.categories?.category || "",
            subCategory: category?.categories?.subCategory || "",
          },
          configName: category?.configName || "",
          description: category?.description || "",
          ticketType: category?.ticketType || "",
          company_id: category?.company_id || "" ,
          copy_company_id:  "" ,
          isactive: category?.isActive ?? true,
          isTicketNotAllowed: category?.isTicketNotAllowed?? false,
          ticketingportal: category?.ticketingportal ?? true,
          adminportal: category?.adminportal ?? true,
          ticketingportalgroup: category?.ticketingportalgroup || [],
          adminportalgroup: category?.adminportalgroup || [],
          questions: category?.questions || [],
          // knowledgeBase: {
          //               title: category?.knowledgeBase?.title || "",
          //               content: category?.knowledgeBase?.content || "",
          //             },
          isRouting: category?.isRouting ?? false,
          routing: {
            adminGroup: category?.routing?.adminGroup
              ? Number(category.routing.adminGroup)
              : null,
            assignedTo: category?.routing?.assignedTo
              ? Number(category.routing.assignedTo)
              : null,
          },
          questionMode: category?.questionMode || "custom",
          templateId: category?.templateId || null,
          childDepartments: category?.childDepartments || [],
        }
      : {
          categories: {
            category: "",
            subCategory: "",
          },
          configName: "",
          description: "",
          ticketType: "Ticket",
          company_id: "",
          copy_company_id: "",
          isactive: true,
          isTicketNotAllowed: false,
          ticketingportal: true,
          adminportal: true,
          ticketingportalgroup: [23],
          adminportalgroup: [24],
          questions: [],
          // knowledgeBase: {
          //       title: "",
          //       content: "",
          //     },
          isRouting: true,
          routing: {
            adminGroup: null,
            assignedTo: null,
          },
          questionMode: "custom",
          templateId: null,
          childDepartments: [],
        };

  const validationSchema = Yup.object({
    categories: Yup.object({
      category: Yup.object().nullable().required("Category is required"),
      subCategory: Yup.object().nullable().required("Sub Category is required"),
    }),
    //configname: Yup.string().required("Config name is required"),
    description: Yup.string().required("Description is required"),
    ticketType: Yup.string().required("Ticket Type is required"),
    company_id: Yup.string().required("Company is required"),
    isactive: Yup.boolean(),
    isTicketNotAllowed: Yup.boolean(),
    ticketingportalgroup: Yup.array().when("ticketingportal", {
      is: true,
      then: (schema) =>
        schema.min(1, "Select at least one group for ticketing portal"),
      otherwise: (schema) => schema.notRequired(),
    }),
    adminportalgroup: Yup.array().when("adminportal", {
      is: true,
      then: (schema) =>
        schema.min(1, "Select at least one group for admin portal"),
      otherwise: (schema) => schema.notRequired(),
    }),
     // ----------------------DYNAMIC VALIDATION FOR QUESTIONS ----------------------
  questions: Yup.array()
  .when("ticketType", {
    is: "Ticket",
    then: (schema) =>
      schema
        .of(
          Yup.object({
            name: Yup.string().required("Question is required"),
            answerType: Yup.string().required("Answer Type is required"),
            required: Yup.boolean(),
            is_active: Yup.boolean(),
          })
        )
        .test(
          "unique-questions",
          "Question already exists with the same answer type",
          (questions) => {
            if (!Array.isArray(questions)) return true;

            const seen = new Set();

            for (const q of questions) {
              if (!q?.name || !q?.answerType) continue;

              const key =
                q.name.trim().toLowerCase() +
                "__" +
                q.answerType;

              if (seen.has(key)) {
                return false;
              }
              seen.add(key);
            }

            return true;
          }
        ),
    otherwise: (schema) => schema.notRequired(),
  }),


    // ----------------------DYNAMIC VALIDATION FOR ROUTING ----------------------
    routing: Yup.object().when("ticketType", {
      is: "Ticket",
      then: (schema) =>
        schema.test(
          "routing-required",
          "Select at least one of Admin Group or Assigned To",
          (value) => value?.adminGroup || value?.assignedTo
        ),
      otherwise: (schema) => schema.notRequired(),
    }),

    // ----------------------VALIDATE WORKFLOW CHILD DEPARTMENTS ----------------------
    childDepartments: Yup.array().when("ticketType", {
      is: "Workflow",
      then: (schema) =>
        schema.of(
          Yup.object({
            departmentId: Yup.string().required("Department is required"),
            assignedToId: Yup.number().nullable(),
            instructions: Yup.string().required("Instructions are required"),
            status: Yup.boolean().required(),
            order: Yup.number().required(),
          })
        ),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const handleAdminGroupChange = (e, setFieldValue) => {
    const selectedGroupId = e.target.value;
    setFieldValue("routing.adminGroup", selectedGroupId);
    console.log("Selected id", selectedGroupId);
    dispatch(loadGroupByIDJobTitlesGetDataRequest(selectedGroupId));
    // After the API success (through Redux), employees data will come in store
  };

  useEffect(() => {
    if (group && Array.isArray(group)) {
      setEmployees(group);
    }
  }, [group]);

  const loadEmployeesByGroupId = (groupId) => {
  if (!groupId) return;
  dispatch(loadGroupByIDJobTitlesGetDataRequest(groupId));
};


useEffect(() => {
  if (!isEditMode) return;
  if (!category || Object.keys(category).length === 0) return;
  if (dbSnapshot) return;

  setDbSnapshot({
    questionMode: category.questionMode || "custom",
    templateId: category.templateId ?? null,
    questions: JSON.parse(JSON.stringify(category.questions || [])),
  });
}, [id, category, dbSnapshot]);

useEffect(() => {
  if (!isEditMode) {
    setDbSnapshot(null);
  }
}, [isEditMode]);

useEffect(() => {
  if (!isEditMode) {
    dispatch(resetCategoryFormUpdateData());
  }
}, [isEditMode, dispatch]);



const handleQuestionModeChange = (
  newMode,
  values,
  setFieldValue
) => {
console.log("handleQuestionModeChange called with:", id, '-----', dbSnapshot);
  // CREATE MODE
  if (!isEditMode || !dbSnapshot) {
    console.log("CREATE MODE: Setting questionMode to", newMode);
    setFieldValue("questionMode", newMode);
    if (newMode === "template") {
      setFieldValue("questions", []);
    } else {
      setFieldValue("templateId", null);
    }
    return;
  }
console.log("handleQuestionModeChange", newMode, values, dbSnapshot);
  // EDIT MODE
  const hasUnsavedChanges =
    // values.questionMode !== dbSnapshot.questionMode ||
    JSON.stringify(values.questions) !== JSON.stringify(dbSnapshot.questions) ||
    values.templateId !== dbSnapshot.templateId;
console.log("hasUnsavedChanges", hasUnsavedChanges);
  if (!hasUnsavedChanges) {
    setFieldValue("questionMode", newMode);
    return;
  }

  const confirmed = window.confirm(
    "Switching question mode will discard your unsaved changes. Continue?"
  );

  if (!confirmed) return;

  // Restore DB values
  setFieldValue("questionMode", dbSnapshot.questionMode);
  setFieldValue("templateId", dbSnapshot.templateId);
  setFieldValue("questions", dbSnapshot.questions);

  setTimeout(() => {
  setFieldValue("questionMode", newMode);
  if (newMode === "template") {
    setFieldValue("questions", []);
  } else {
    setFieldValue("templateId", null);
  }
}, 0);
};



  const handleCategoryChange = (selectedOption, setFieldValue) => {
    if (!selectedOption) {
      // clearing category
      setFieldValue("categories.category", null);
      setFieldValue("categories.subCategory", null);
      setSubCategories([]);
      return;
    }

    setFieldValue("categories.category", {
      id: selectedOption.id,
      label: selectedOption.label,
      value: selectedOption.value,
      __isNew__: false,
    });

    const relatedSubs =
      selectedOption?.sub_category?.map((sub) => ({
        id: sub.s_id,
        label: sub.s_name,
        value: sub.s_name,
        __isNew__: false,
      })) || [];

    setSubCategories(relatedSubs);
    setFieldValue("categories.subCategory", null);
  };

  const handleSubmit = (values, resetForm) => {
    const payload = {
      ...values,
      categories: {
        category: values.categories.category,
        subCategory: values.categories.subCategory,
      },
      configName: `${values.categories.category?.label || ""} - ${
        values.categories.subCategory?.label || ""
      }`,
      company_id: values.company_id,
      copy_company_id: values.copy_company_id,

      routing: {
        adminGroup: values.routing.adminGroup
          ? Number(values.routing.adminGroup)
          : null,
        assignedTo: values.routing.assignedTo
          ? Number(values.routing.assignedTo)
          : null,
      },
    };
      if (values.questionMode === "template") {
    payload.templateId = values.templateId;
    payload.questions = []; 
  } else {
    payload.templateId = null;
    payload.questions = values.questions;
  }

  console.log("Payload", payload);
    // If editing, include ID
    if (id && !isNaN(Number(id))) {
      payload.id = id;
      console.log("Updating Category Payload:", payload);
      dispatch(loadCategoryUpdateDataRequest(payload));
    } else {
      console.log("Creating New Category Payload:", payload);
      dispatch(loadCategoryFormAddDataRequest(payload));
    }

    // After dispatch, navigate or reset form based on saveType
    if (saveType === "save") {
      navigate("/categories");
    } else if (saveType === "saveAndNew") {
      resetForm();
      setSaveType("");
      setShouldReload(true);
    }
  };

  //Reload page after request processed
  useEffect(() => {
    if (shouldReload && !loading) {
      dispatch(dispatch(loadCategorySubCategoryDataRequest()));
      setShouldReload(false);
    }
  }, [loading, shouldReload]);

  


  return (
    <>
      <Row className="detailsPageHeader">
        <Col>
          <Breadcrumbs
            children={[
              { href: "/categories/", label: CATEGORIES },
              {
                href: "/categoryform/",
                label: category?.configName || CATEGORYFORM,
              },
            ]}
          />
        </Col>
        <Col>
          <div className="float-end">
             {/* In CategoryForm return */}
              {isEditMode && (
                <PrevNextButtons currentId={id} basePath={"/categoryform/"} name={CATEGORIES} />
              )}
            <Link to="/categories/">
              <DefaultButton
                buttonClass="default-btn-color"
                buttonTitle={BACKTOLIST}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                enableReinitialize={!!id && !Number.isNaN(Number(id))}
                onSubmit={(values, { resetForm }) =>
                  handleSubmit(values, resetForm)
                }
              >
                {({ setFieldValue, values, resetForm }) => (
                  <Form>
                {!isEditMode && (
                <Card className="mb-4">
                  <Card.Header>Copy from Existing</Card.Header>
                  <Card.Body>
                    <Row className="g-3">
                      {/* ---------------- INHERIT CONFIGURATION ---------------- */}

                      <Col md={6}>
                        <label className="form-label">Company to Copy</label>
                        <select
                          className="form-select"
                          value={values.copy_company_id}
                          onChange={(e) => setFieldValue("copy_company_id", e.target.value)}
                        >
                          <option value="">Select Company</option>
                          {companies.map((company) => (
                            <option key={company.id} value={company.id}>
                              {company.company_name}
                            </option>
                          ))}
                        </select>
                      </Col>

                      <Col md={6}>
                        <CategoryInheritFrom
                          setFieldValue={setFieldValue}
                          setSubCategories={setSubCategories}
                          companyId={values.copy_company_id}
                        />
                      </Col>

                    </Row>
                  </Card.Body>
                </Card>
              )}
      {/* ---------------- CATEGORY CONFIGURATION ---------------- */}
                    <Card className="mb-4">
                      <Card.Header>Category Configuration</Card.Header>                      
                      <Card.Body>
                        
                        <Row className="g-3">
                          {/* CATEGORY */}
                          <Col md={6}>
                            <label className="form-label">
                              {" "}
                              Category <span className="error-text">
                                *
                              </span>{" "}
                            </label>
                            <FormikCreatableSelect
                              name="categories.category"
                              value={values.categories.category}
                              onChange={(name, option) =>
                                handleCategoryChange(option, setFieldValue)
                              }
                              options={
                                categories?.data?.map((cat) => ({
                                  id: cat.id,
                                  label: cat.name,
                                  value: cat.name,
                                  sub_category: cat.sub_category,
                                  __isNew__: false,
                                })) || []
                              }
                              placeholder="Type or select category"
                              isDisabled={isEditMode}
                            />
                            <ErrorMessage
                              name="categories.category"
                              component="div"
                              className="error-text"
                            />
                          </Col>

                          {/* SUB CATEGORY */}
                          <Col md={6}>
                            <label className="form-label">
                              {" "}
                              Sub Category <span className="error-text">
                                *
                              </span>{" "}
                            </label>
                            <FormikCreatableSelect
                              name="categories.subCategory"
                              value={values.categories.subCategory}
                              onChange={(name, option) =>
                                setFieldValue(
                                  "categories.subCategory",
                                  option
                                    ? {
                                        id: option.id,
                                        label: option.label,
                                        value: option.value,
                                        __isNew__: false,
                                      }
                                    : null // when cleared
                                )
                              }
                              options={subCategories}
                              placeholder="Type or select sub category"
                              isDisabled={isEditMode}
                            />
                            <ErrorMessage
                              name="categories.subCategory"
                              component="div"
                              className="error-text"
                            />
                          </Col>

                          {/* <Col md={6}>
                              <label className="form-label"> Configuration Name <span className="error-text">*</span> </label>
                              <Field
                                type="text"
                                name="configname"
                                className="form-control"
                                placeholder="Enter config name"
                              />
                              <ErrorMessage name="configname" component="div" className="error-text" />
                          </Col> */}
                          <Col md={6}>
                            <label className="form-label">
                              Ticket Type <span className="error-text">*</span>
                            </label>
                            <select
                              className="form-select"
                              value={values.ticketType}
                              onChange={(e) =>
                                setFieldValue("ticketType", e.target.value)
                              }
                            >
                              {ticketTypes.map((ttype) => (
                                <option key={ttype.value} value={ttype.value}>
                                  {ttype.label}
                                </option>
                              ))}
                            </select>
                            <ErrorMessage
                              name="ticketType"
                              component="div"
                              className="error-text"
                            />
                          </Col>
                          {/* COMPANY */}
                            <Col md={6}>
                              <label className="form-label">
                                Company <span className="error-text">*</span>
                              </label>

                              <select
                                className="form-select"
                                value={values.company_id}
                                onChange={(e) => setFieldValue("company_id", e.target.value)}
                              >
                                <option value="">Select Company</option>

                                {companies.map((company) => (
                                  <option key={company.id} value={company.id}>
                                    {company.company_name}
                                  </option>
                                ))}
                              </select>

                              <ErrorMessage
                                name="company_id"
                                component="div"
                                className="error-text"
                              />
                            </Col>
                          <Col md={6}>
                            <div className="d-flex align-items-center mt-4">
                              <FormikCheckboxField
                                name="isactive"
                                label="Active"
                                value={values.isactive}
                                setFieldValue={setFieldValue}
                                onChange={(val) =>
                                  setFieldValue("isactive", val)
                                }
                              />
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="d-flex align-items-center mt-4">
                              <FormikCheckboxField
                                name="isTicketNotAllowed"
                                label="Don't Allow Ticket Creation"
                                value={values.isTicketNotAllowed}
                                setFieldValue={setFieldValue}
                                onChange={(val) =>
                                  setFieldValue("isTicketNotAllowed", val)
                                }
                              />
                            </div>
                          </Col>
                          <Col md={12}>
                            <label className="form-label">
                              Description <span className="error-text">*</span>
                            </label>
                            <Field
                              as="textarea"
                              name="description"
                              className="form-control"
                              placeholder="Enter description"
                              rows={4}
                            />
                            <ErrorMessage
                              name="description"
                              component="div"
                              className="error-text"
                            />
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    {/* ---------------- VISIBILITY ACCESS CONTROL ---------------- */}
                    <Card className="mb-4">
                      <Card.Header>Visibility & Access Control</Card.Header>
                      <Card.Body>
                        <Row className="g-3">
                          <Col md={6} className="d-flex align-items-center">
                            <FormikCheckboxField
                              name="ticketingportal"
                              label="Visibility for ticketing portal user"
                              value={values.ticketingportal}
                              setFieldValue={setFieldValue}
                              onChange={(val) =>
                                setFieldValue("ticketingportal", val)
                              }
                            />
                          </Col>

                          <Col md={6} className="d-flex align-items-center">
                            <FormikCheckboxField
                              name="adminportal"
                              label="Visibility for admin user"
                              value={values.adminportal} 
                              setFieldValue={setFieldValue}
                              onChange={(val) =>
                                setFieldValue("adminportal", val)
                              }
                            />
                          </Col>

                          {/* Ticketing portal group */}
                          <Col md={6}>
                            <FormikSelectField
                              name="ticketingportalgroup"
                              value={values.ticketingportalgroup}
                              onChange={setFieldValue}
                              placeholder="Select a user group"
                              isMulti
                              required
                              disabled={!values.ticketingportal} //  disable when unchecked
                            >
                              {userGroup
                              // .filter((user) => {
                              //     if (values.ticketType === "Workflow") {
                              //       return user.group_name === "All Administrator";
                              //     }
                              //     // Ticket → show everything (including All Users)
                              //     return true;
                              //   })
                                .map((user) => (
                                  <option key={user.group_id} value={user.group_id}>
                                    {user.group_name}
                                  </option>
                                ))}
                            </FormikSelectField>
                            <ErrorMessage
                              name="ticketingportalgroup"
                              component="div"
                              className="error-text"
                            />
                          </Col>

                          {/* Admin portal group */}
                          <Col md={6}>
                            <FormikSelectField
                              name="adminportalgroup"
                              value={values.adminportalgroup}
                              onChange={setFieldValue}
                              placeholder="Select an admin group"
                              isMulti
                              required
                              disabled={!values.adminportal} //  disable when unchecked
                            >
                              {adminGroup.map((admin) => (
                                <option
                                  key={admin.group_id}
                                  value={admin.group_id}
                                >
                                  {" "}
                                  {admin.group_name}{" "}
                                </option>
                              ))}
                            </FormikSelectField>
                            <ErrorMessage
                              name="adminportalgroup"
                              component="div"
                              className="error-text"
                            />
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    {/* ---------------- CATEGORY QUESTION ---------------- */}

                    {values.ticketType === "Ticket" ? (
                        <>
                          <div className="col-md-12">
                            <CategoryQuestions
                              values={values}
                              setFieldValue={setFieldValue}
                              isEditMode={!!id && !Number.isNaN(Number(id))}
                              onQuestionModeChange={(mode) =>
                                handleQuestionModeChange(mode, values, setFieldValue)
                              }
                            />
                          </div>

                          <ErrorMessage name="templateId" component="div" className="error-text" />
                          <ErrorMessage name="questions" component="div" className="error-text" />

                          <CategoryRoutingRules
                            key={shouldReload}
                            values={values}
                            setFieldValue={setFieldValue}
                            adminGroup={adminGroup}
                            employees={employees}
                            handleAdminGroupChange={handleAdminGroupChange}
                            initialRouting={category?.routing}
                          />
                        </>
                      ) : (
                        <>
                          <WorkflowDepartments
                            values={values}
                            setFieldValue={setFieldValue}
                            adminGroups={adminGroup || []}
                            employees={employees || []}
                            loadEmployeesByGroup={loadEmployeesByGroupId}
                          />
                        </>
                      )}


                    {/* ---------------- SUBMIT BUTTON ---------------- */}
                    <div className="d-flex gap-3 justify-content-end mt-4">
                      {/* Cancel Button */}
                      <DefaultButton
                        buttonClass={"btn btn-secondary me-2"}
                        buttonTitle="Cancel"
                        buttonType="button"
                        actionBlock={() => resetForm()}
                      />
                      {/* Save & New Button */}
                      <DefaultButton
                        buttonClass={"btn btn-secondary default-btn-color"}
                        buttonTitle="Save & New"
                        buttonType="button"
                        actionBlock={() => {
                          setSaveType("saveAndNew"); // set saveType
                          document
                            .getElementById("categoryFormSubmitBtn")
                            .click();
                        }}
                      />

                      {/* Save Button */}
                      <DefaultButton
                        buttonClass={"btn btn-secondary default-btn-color"}
                        buttonTitle={SAVE}
                        buttonType="button"
                        actionBlock={() => {
                          setSaveType("save");
                          document
                            .getElementById("categoryFormSubmitBtn")
                            .click();
                        }}
                      />

                      {/* Hidden submit button for Formik */}
                      <button
                        type="submit"
                        id="categoryFormSubmitBtn"
                        style={{ display: "none" }}
                      />
                    </div>
                    <div className="mb-3"></div>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default CategoryForm;
